<template>
  <div>
    <div class="service_min_div">
      <div class="service_min_item">
        <div>
          <img src="../../../static/img/设备运维1.png" />
        </div>
        <p>设计咨询</p>
      </div>
      <div class="service_min_item">
        <div>
          <img src="../../../static/img/设备运维2.png" />
        </div>
        <p>安装监理</p>
      </div>
      <div class="service_min_item">
        <div>
          <img src="../../../static/img/设备运维3.png" />
        </div>
        <p>承接查验</p>
      </div>
      <div class="service_min_item">
        <div>
          <img src="../../../static/img/设备运维4.png" />
        </div>
        <p>平台部署</p>
      </div>
      <div class="service_min_item">
        <div>
          <img src="../../../static/img/设备运维5.png" />
        </div>
        <p>设备维保</p>
      </div>
      <div class="service_min_item">
        <div>
          <img src="../../../static/img/设备运维6.png" />
        </div>
        <p>更新改造</p>
      </div>
    </div>

    <div class="father">
      <div>
        <h1>Main heading</h1>
        <h2>Sub heading</h2>
      </div>
      <div>
        <article>
          <img src="../../../static/img/业务介绍物业1.jpg" />
          <h2></h2>
          <div class="content_div">
            <div class="item_div">
              <hr class="line" />
              <p class="num_title">2</p>
              <div>
                <p class="title">大核心</p>
              </div>
            </div>
            <p>一体式集约化运营模式</p>
            <p>设备设施运营平台</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/业务介绍物业2.jpg" />
          <div class="content_div">
            <div class="item_div">
              <hr class="line" />
              <p class="num_title">6</p>
              <div>
                <p class="title">大业务类型</p>
              </div>
            </div>
            <p>顾问咨询</p>
            <p>承接查验</p>
            <p>电梯监管</p>
            <p>机电维保</p>
            <p>节能改造</p>
            <p>平台服务</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/业务介绍物业3.jpg" />
          <div class="content_div">
            <div class="item_div">
              <hr class="line" />
              <p class="num_title">6</p>
              <div>
                <p class="title">大业务特色</p>
              </div>
            </div>
            <p>系统初始化</p>
            <p>机房标准化</p>
            <p>工作自动化</p>
            <p>定期评估</p>
            <p>远程监测</p>
            <p>流水线作业</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/业务介绍物业4.jpg" />
          <div class="content_div">
            <div class="item_div">
              <hr class="line" />
              <p class="num_title">9</p>
              <div>
                <p class="title">大服务资源</p>
              </div>
            </div>
            <div class="double_div">
              <div class="double_left">
                <p>物资集采资源</p>
                <p>集团专家资源</p>
                <p>设备厂家资源</p>
                <p>施工方资源</p>
                <p>垂直服务商资源</p>
              </div>
              <div class="double_right">
                <p>设计院资源</p>
                <p>分包方资源</p>
                <p>众包方资源</p>
                <p>培训资源</p>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.service_min_div {
  margin-top: 10rem;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;

  .service_min_item {
    height: 15rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;

    div {
      width: 8rem;
      height: 8rem;
    }

    img {
      width: 7rem;
      height: 7rem;
      object-fit: contain;
    }

    p {
      font-size: 2.1rem;
      font-family: regular;
    }
  }
}

.father {
  width: 90%;
  height: 40rem;
  margin: 5rem auto;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: var(--textBlue60);
    position: absolute;
    top: 0;

    .double_div {
      margin-left:5rem;
      display: flex;
      height: 100%;
      width: 100%;

      .double_left {
        padding:0;
        position: relative;
        display: block;
        // overflow: hidden;
        background:transparent;
        height: 100%;
        bottom:0;
        p{
          margin:0;
          text-align :left;
        }
      }

      .double_right {
        display: block;
        height: 100%;
        p{
          margin:0;
        }
      }
    }

    h3 {
      margin: 5rem 0 0 5rem;
      font-size: 3rem;
      font-family: bold;
    }

    p {
      margin: 0 5rem 0 5rem;
      width: auto;
      font-size: 1.8rem;
      font-family: light;
    }

    .first_p {
      margin: 5rem 5rem 0 5rem;
    }

    .item_div {
      display: flex;
      position: relative;
      width: fit-content;
      top: 0;
      margin: 1rem 0 2rem;
      background: transparent;
      align-items: center;

      .line {
        border: 1px solid white;
        width: 5rem;
      }

      div {
        width: fit-content;
      }

      .num_title {
        font-size: 8rem;
        font-family: number;
        margin: 0 1rem 0;
      }

      .title {
        font-size: 2.5rem;
        font-family: regular;
        margin: 0;
      }

      .subtitle {
        font-size: 1.3rem;
        font-family: light;
        margin: 0;
      }
    }

    .item_content {
      height: 6.5rem;
      width: 33rem;
      background-image: url('../../../static/img/餐饮2bannerbg.png');
      background-repeat: no-repeat;
      background-size: contain;
      font-size: 2rem;
      font-family: regular;
      line-height: 5rem;
      color: var(--textGary80);
      text-align: center;
      position: relative;
      margin: auto;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 25%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 20%;
  }

  div + div article:hover {
    width: 50%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }

  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>